import { createSlice } from "@reduxjs/toolkit";

const workFlowSlice = createSlice({
    name: "workFlow",
    initialState: {
        isLoading: false,
        workFlowTypeByGroup: [],
        workFlowByType: {},
        currentFlow: "MAIN_FLOW",
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setWorkFlowTypeByGroup(state, action) {
            state.workFlowTypeByGroup = action.payload;
        },
        setWorkFlowByType(state, action) {
            state.workFlowByType = action.payload;
        },
        setCurrentFlow(state, action) {
            state.currentFlow = action.payload;
        },
    },
});

export const {
    setIsLoading,
    setWorkFlowTypeByGroup,
    setWorkFlowByType,
    setCurrentFlow,
} = workFlowSlice.actions;
export default workFlowSlice.reducer;
